"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsClass = void 0;

var react_gtm_module_1 = __importDefault(require("react-gtm-module"));

var AnalyticsClass = function () {
  function AnalyticsClass(env, gtmTag, errorHandler) {
    var _this = this;

    this.analyticsEnabled = false;

    this.logEvent = function (params) {
      if (_this.analyticsEnabled) {
        try {
          react_gtm_module_1.default.dataLayer({
            dataLayer: params
          });
        } catch (e) {
          console.log(e);

          if (typeof _this.errorHandler !== 'undefined') {
            _this.errorHandler(e);
          }
        }
      }
    };

    this.trackCTAButton = function (routeName) {
      return function () {
        _this.logEvent({
          event: 'Click',
          category: routeName + " page",
          label: "CTA button - " + routeName
        });
      };
    };

    this.trackQuizAnswer = function (category, label) {
      _this.logEvent({
        event: 'Quiz question answered',
        category: category,
        label: label
      });
    };

    this.trackShippingFormSubmitted = function () {
      _this.logEvent({
        event: 'Shipping form',
        category: 'Submit',
        label: 'Shipping form submitted'
      });
    };

    this.trackPaymentSubmit = function (paymentData) {
      var method = paymentData === null || paymentData === void 0 ? void 0 : paymentData.method;
      var title = paymentData === null || paymentData === void 0 ? void 0 : paymentData.product;

      if (typeof title !== 'string') {
        title = title.title;
      }

      _this.logEvent({
        event: 'payment_initialized',
        payment_method: method,
        subscription_plan: title
      });
    };

    this.trackPurchase = function (orderId, currency) {
      var _a, _b;

      var product = (_b = (_a = global.window) === null || _a === void 0 ? void 0 : _a.kiloCheckout) === null || _b === void 0 ? void 0 : _b.getSelectedProduct();

      _this.logEvent({
        event: 'purchase_main',
        pageCategory: 'successPage',
        transactionId: orderId,
        transactionTotal: product === null || product === void 0 ? void 0 : product.price,
        currencyCode: currency,
        transactionProducts: [{
          sku: product === null || product === void 0 ? void 0 : product.key,
          name: product === null || product === void 0 ? void 0 : product.title,
          price: product === null || product === void 0 ? void 0 : product.price,
          quantity: 1
        }]
      });
    };

    this.trackPurchaseUpsell = function (orderId, product) {
      var _a, _b, _c;

      _this.logEvent({
        event: 'purchase_upsell',
        pageCategory: 'successPage',
        transactionId: orderId,
        transactionTotal: (_a = product === null || product === void 0 ? void 0 : product.prices) === null || _a === void 0 ? void 0 : _a[0].final_price,
        currencyCode: 'USD',
        transactionProducts: [{
          sku: product === null || product === void 0 ? void 0 : product.sku,
          name: product === null || product === void 0 ? void 0 : product.name,
          price: (_c = (_b = product === null || product === void 0 ? void 0 : product.prices) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.final_price,
          quantity: 1
        }]
      });
    };

    this.errorHandler = errorHandler;
    this.analyticsEnabled = env === 'production';

    if (this.analyticsEnabled) {
      if (typeof document !== 'undefined' && typeof react_gtm_module_1.default !== 'undefined') {
        react_gtm_module_1.default.initialize({
          gtmId: gtmTag
        });
      } else {
        console.warn('TagManager is undefined');
      }
    }
  }

  return AnalyticsClass;
}();

exports.AnalyticsClass = AnalyticsClass;